import { create } from "zustand";

interface WelcomeStore {
  isOpenModalWelcomeGift: boolean;
  setIsOpenModalWelcomeGift: (bool: boolean) => void;
}

export const useWelcomeStore = create<WelcomeStore>((set) => ({
  isOpenModalWelcomeGift: false,
  setIsOpenModalWelcomeGift: (isOpenModalWelcomeGift: boolean) => set({ isOpenModalWelcomeGift }),
}));
